<script>
  import Carousel from "$lib/components/ui/carousel.svelte"
  import PercsLogo from "$lib/icons/percs-logo.svelte"
</script>

<section class="h-screen flex flex-col md:flex-row overflow-y-scroll overflow-x-hidden md:overflow-y-hidden">
  <div class="md:flex-1 bg-orange-light">
    <div class="text-blue-900 text-2xl font-bold p-10 text-center h-auto">
      1000+ INDUSTRY LEADING CLIENTS EXCELLING AT ENGAGING WITH THEIR ONCHAIN AUDIENCE.
    </div>
    <Carousel />
  </div>
  <div class="md:flex-1 p-8 order-first md:order-last">
    <div class="flex justify-center max-h-16 items-center pt-4 pr-4 pl-4">
      <div class="w-auto md:px-28 sm:py-4 sm:px-4">
        <a class="h-8 w-auto" href="https://percs.app" target="_blank">
          <PercsLogo />
        </a>
      </div>
    </div>
    <div class="flex flex-col justify-center items-center py-32 sm:px-6 lg:px-8 bg-white border-none">
      <slot name="content" />
    </div>
  </div>
</section>
